exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".call-to-action {\n  color: #272623;\n  font-family: 'Roboto Condensed';\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 3px;\n  margin-bottom: 48px;\n  text-align: center;\n  text-transform: uppercase; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main